module.exports = __webpack_public_path__ + "static/GoToCRMIntegratedTelephony-96375bcf7bfae5c1dbb8844b65dc48ba.pdf";